import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { Dialog } from '@frontend/components/Dialog';
import { WalletButton } from '@frontend/components/WalletButton';
import * as React from 'react';

var ContentConnectDialog = _styled("div", true ? {
  target: "etp4hw20"
} : {
  target: "etp4hw20",
  label: "ContentConnectDialog"
})(true ? {
  name: "wxpapj",
  styles: "padding:1.5rem 0.5rem 0;width:29.375rem;height:31.375rem;max-width:100%;display:grid;grid-gap:1rem;grid-auto-rows:max-content"
} : {
  name: "wxpapj",
  styles: "padding:1.5rem 0.5rem 0;width:29.375rem;height:31.375rem;max-width:100%;display:grid;grid-gap:1rem;grid-auto-rows:max-content",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ConnectWalletDialogRaw = function ConnectWalletDialogRaw(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      handleConnect = _ref.handleConnect;
  return _jsx(Dialog, {
    open: open,
    onClose: onClose,
    title: "Connect Wallet",
    mobileFullScreen: true,
    children: _jsxs(ContentConnectDialog, {
      children: [_jsx(WalletButton, {
        onClick: handleConnect('metamask'),
        label: _jsx("h6", {
          children: "MetaMask"
        }),
        connectorId: 'metamask'
      }), _jsx(WalletButton, {
        onClick: handleConnect('walletconnect'),
        label: _jsx("h6", {
          children: "Wallet Connect"
        }),
        connectorId: 'walletconnect'
      }), _jsx(WalletButton, {
        onClick: handleConnect('bsc'),
        label: _jsx("h6", {
          children: "Binance Chain Wallet"
        }),
        connectorId: 'bsc'
      }), _jsx(WalletButton, {
        onClick: handleConnect('safe-pal'),
        label: _jsx("h6", {
          children: "SafePal Wallet"
        }),
        connectorId: 'safe-pal'
      }), _jsx(WalletButton, {
        onClick: handleConnect('trust-wallet'),
        label: _jsx("h6", {
          children: "Trust Wallet"
        }),
        connectorId: 'trust-wallet'
      })]
    })
  });
};

export var ConnectWalletDialog = /*#__PURE__*/React.memo(ConnectWalletDialogRaw);